import(/* webpackMode: "eager" */ "/home/ec2-user/workspace/OPAM-project/frontend-next/src/app/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["SessionMonitorProvider"] */ "/home/ec2-user/workspace/OPAM-project/frontend-next/src/components/SessionMonitorProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ec2-user/workspace/OPAM-project/frontend-next/src/context/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormProvider"] */ "/home/ec2-user/workspace/OPAM-project/frontend-next/src/context/FormContext.tsx");
